import { type Dec, D } from "@ftr/tax-core";

/** Whole dollars for headline numbers; the "Why" panel shows cents. */
export function usd(v: Dec, opts: { cents?: boolean; sign?: boolean } = {}): string {
  const places = opts.cents ? 2 : 0;
  const n = v.toDecimalPlaces(places, D.ROUND_HALF_UP);
  const abs = n.abs().toFixed(places);
  const [int, frac] = abs.split(".");
  const grouped = int!.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const body = "$" + grouped + (frac ? "." + frac : "");
  if (n.lessThan(0)) return "−" + body;
  return opts.sign && n.greaterThan(0) ? "+" + body : body;
}

export function pct(v: Dec, places = 1): string {
  return v.times(100).toDecimalPlaces(places, D.ROUND_HALF_UP).toFixed(places) + "%";
}

/** Format a money string from the trace (already "1234.56"). */
export function traceValue(s: string): string {
  return usd(new D(s), { cents: true });
}

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export function shortDate(iso: string): string {
  const [y, m, d] = iso.split("-").map(Number);
  return `${MONTHS[m! - 1]} ${d}, ${y}`;
}

/** Today's date in the viewer's time zone as YYYY-MM-DD. The tax core never reads the clock itself. */
export function todayIso(): string {
  const t = new Date();
  const p = (n: number) => String(n).padStart(2, "0");
  return `${t.getFullYear()}-${p(t.getMonth() + 1)}-${p(t.getDate())}`;
}

/** Whole days from one YYYY-MM-DD date to another, counted on the calendar so daylight saving can't shift it. */
export function daysUntil(iso: string, from: string): number {
  const a = Date.UTC(+from.slice(0, 4), +from.slice(5, 7) - 1, +from.slice(8, 10));
  const b = Date.UTC(+iso.slice(0, 4), +iso.slice(5, 7) - 1, +iso.slice(8, 10));
  return Math.round((b - a) / 86_400_000);
}
